import mimeTypes from 'mime-types';

export function getFileType(file: { name: string; type: string }) {
    // In IE11 de file type is not always filled
    // https://stackoverflow.com/questions/32849014/ie-11-and-ie-edge-get-file-type-failed
    let result = file.type;
    if (!result) {
        const mimeType = mimeTypes.lookup(file.name);
        if (mimeType) {
            result = mimeType;
        }
    }

    return result;
}
